import { render, staticRenderFns } from "./BranchNotificationList.vue?vue&type=template&id=79913c24&"
import script from "./BranchNotificationList.vue?vue&type=script&lang=js&"
export * from "./BranchNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./BranchNotificationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports